//breadcrumbs service
app.provider("_$breadcrumbs",function(){
   
        var names={};
        
        
        this.setBreadcrumbs=function(n){
            
          names=n;
          
        };
   
        this.$get=function(){
            
          return new function(){
              
            this.breads=[];
            
            
            //generates from states
            this.generateByStates=function(toState){
                
                this.clear();
                var breads=toState.name.split(/[\._]/);
                
                
                for (var key in breads){
                    
                    if (names.hasOwnProperty(breads[key])){
                        
                        this.push(names[breads[key]].label,names[breads[key]].state);
                    }
                }
                
            };
            
            //pus last
            this.push=function(label,state){

                this.breads.push({label:label, state:state});    
            };

            //remove last
            this.pop=function(){

                this.breads.pop();

            };

            //clears all
            this.clear=function(){


               this.breads.length = 0;
               
            };
      
          };
            
        };
   
        
    
});


